import $ from 'jquery';
import { breakpoints } from './_site';

let $lastFocusedHeaderMenu;
export const timeout = {};
export const toggle = () => {
    $('body').toggleClass('menu-active');
    $('body').removeClass('cart-active sidebar-active submenu-active');
};
export const responsiveClick = ($menuItem) => {
    var $item = $menuItem.parent(),
        subMenuClass = '.submenu-nav, .products-nav',
        menuItemClass = 'menu__item',
        menuItemClassHover = menuItemClass + '--hover',
        $submenu = $item.find(subMenuClass);

    if (!$submenu.length) {
        return false;
    }

    // reset others
    $('.menu-nav')
        .find('.' + menuItemClass)
        .not($item)
        .removeClass(menuItemClassHover);
    $(subMenuClass)
        .not($submenu)
        .stop(true)
        .slideUp(200);

    // active item
    $item.toggleClass(menuItemClassHover);
    $('.menu').toggleClass('menu--active');

    // animate menu
    $submenu.stop(true).slideToggle(200);

    return true;
};
export const responsiveHideMenu = () => {
    $('body').removeClass('header-active menu-active');
    $('.menu--active').removeClass('menu--active');
};
export const responsiveMenu = (flag) => {
    var $menu = $('.header-menu'),
        submenuClass = 'menu__submenu',
        // menuItemClass = 'menu__item',
        // menuItemClassActive = menuItemClass + '--active',
        // menuNavClass = 'menu-nav',
        menuNavClass = 'header-menu',
        menuNavClassDefault = menuNavClass + '--default',
        menuNavClassResponsive = menuNavClass + '--responsive';

    if (flag) {
        $menu.removeClass(menuNavClassDefault).addClass(menuNavClassResponsive);
    } else {
        $menu.removeClass(menuNavClassResponsive).addClass(menuNavClassDefault);
        // $menu.find('.' + menuItemClass).removeClass(menuItemClassActive);
        $menu.find('.' + submenuClass).css({
            display: '',
        });

        $('.menu__item--toggle--active').toggleClass(
            'menu__item--toggle--active'
        );
    }
};
export const resize = () => {
    var $window = $(window);

    // md
    if ($window.width() < breakpoints.md) {
        responsiveMenu(true);
    } else {
        responsiveMenu(false);

        responsiveHideMenu();
    }
};
export const defaultFocus = ($menuItem) => {
    // var $item = $menuItem,
    var $item = $menuItem.parent(),
        subMenuClass = '.submenu-nav, .products-nav',
        // menuItemClass = 'menu__item',
        // menuItemClassHover = menuItemClass + '--hover',
        $submenu = $item.find(subMenuClass),
        $headerMenu = $item.closest('.header-menu');

    // // reset others
    // $('.menu-nav').find('.' + menuItemClass).not($item).removeClass(menuItemClassHover);

    // $item.addClass(menuItemClassHover);

    if ($submenu.length) {
        // $('body').addClass('submenu-active');
        $headerMenu.addClass('header-menu--active');
    } else {
        $('body').removeClass('submenu-active');
        $headerMenu.removeClass('header-menu--active');
    }

    $lastFocusedHeaderMenu = $headerMenu;
};
export const defaultBlur = ($headerMenu) => {
    // var menuItemClass = 'menu__item',
    //     menuItemClassHover = menuItemClass + '--hover',
    //     $item = $('.' + menuItemClassHover);

    // remove active item
    $('body').removeClass('submenu-active');
    $headerMenu.removeClass('header-menu--active');

    // // remove active item
    // $item.removeClass(menuItemClassHover);

    $lastFocusedHeaderMenu = null;
};
export const forceBlurOtherHeaderMenu = ($el) => {
    // force blur the other part
    var $currentHeaderMenu = $el.closest('.header-menu'),
        $otherHeaderMenu = $('.header-menu').not($currentHeaderMenu);

    defaultBlur($otherHeaderMenu);
};
export const setupSignInBlur = () => {
    // flush blur
    $(document).off('click.signInMenu');

    $(document).on('click.signInMenu', function(e) {
        let $activeMenu = $('.menu__item--toggle--active'),
            $header = $('#header');

        if ($activeMenu.length > 0) {
            if (!$header.is(e.target) && $header.has(e.target).length === 0) {
                // remove event handler from document
                $(document).off('click.signInMenu');

                // remove the active state
                $activeMenu.removeClass('menu__item--toggle--active');
            }
        }
    });
};
export const binds = () => {
    // ---------------- toggle menu
    $('[data-menu-toggle]').on('click.menu', function(event) {
        event.preventDefault();
        toggle();
    });

    // ---------------- menu (default)
    $('#header').on(
        'focusin.menu mouseenter.menu',
        '.header-menu--default a.menu__link',
        function(event) {
            forceBlurOtherHeaderMenu($(this));
            defaultFocus($(this));
        }
    );
    $('#header').on(
        'focusin.menu mouseenter.menu',
        '.header-menu--default',
        function(event) {
            if ($(this).is($lastFocusedHeaderMenu)) {
                clearTimeout(timeout.closeMenu);
            }
        }
    );
    $('#header').on(
        'click.menu',
        '.header-menu--default button.menu__link',
        function(event) {
            forceBlurOtherHeaderMenu($(this));
            defaultFocus($(this));
        }
    );
    $('#header').on(
        'click.menu',
        '.header-menu--default [data-toggle-menu-item]',
        function(event) {
            forceBlurOtherHeaderMenu($(this));

            var $el = $(this),
                $toggle = $el.closest('.menu__item--toggle');

            if ($toggle.length) {
                $toggle.toggleClass('menu__item--toggle--active');
            }

            setupSignInBlur();
        }
    );
    $('#header').on('mouseleave.menu', '.header-menu--default', function(
        event
    ) {
        if (event.target.tagName.toLowerCase() == 'input') return;

        var $el = $(this),
            $headerMenu = $el.closest('.header-menu'),
            timeoutInterval = $headerMenu.hasClass('header-menu--dumb')
                ? 500
                : 250;

        timeout.closeMenu = setTimeout(function() {
            defaultBlur($el);
        }, timeoutInterval);
    });

    // ---------------- menu (responsive)
    $('#header').on(
        'click.menu',
        '.header-menu--responsive .menu__link',
        function(event) {
            if (responsiveClick($(this))) {
                event.preventDefault();
            }
        }
    );

    // $('#footer').on('focusin.menu-opacity mouseenter.menu-opacity`', '[data-track-opacity] .footer-menu__item', function(event) {
    //     opacityMenuFocus($(this), 'footer-menu__item');
    // });
    // $('#footer').on('mouseleave.menu-opacity', '[data-track-opacity]', function(event) {
    //     opacityMenuBlur('footer-menu__item');
    // });

    // ---------------- menu (responsive)

    // // ---------------- menu (tablet responsive)
    // $('#header').on('touchend.menu', '.menu-nav .menu__link', function(event) {
    //     var $el = $(this);
    //
    //     if (responsiveClick($el, 'menu__item')) {
    //         event.preventDefault();
    //
    //         defaultFocus($el);
    //         // $el.trigger('focusin.menu');
    //         $el.parent().trigger('focusin.menu-opacity');
    //     }
    // });
    // $('#header').on('touchend.menu', '.user-action .user-action__link:not([data-behaviour="click"])', function(event) {
    //     var $el = $(this);
    //
    //     if (responsiveClick($el, 'user-action__item')) {
    //         event.preventDefault();
    //
    //         $el.trigger('focusin.menu-user-action');
    //         $el.parent().trigger('focusin.menu-opacity');
    //     }
    // });

    // ---------------- window events
    $(window).on('resize.menu', function() {
        clearTimeout(timeout.menuResize);
        timeout.menuResize = setTimeout(function() {
            resize();
        }, 100);
    });
    $(window).triggerHandler('resize.menu');
};
